<template>
  <v-row class="mx-0 align-center">
    <v-col
      cols="4"
      class="pa-0"
    >
      <span class="font-weight-medium">EPF Number</span>
    </v-col>
    <v-col
      cols="1"
      class="pa-0"
    >
      <span class="font-weight-medium">:</span>
    </v-col>
    <v-col
      cols="7"
      class="pa-0 d-flex align-center"
    >
      <v-progress-circular
        v-if="loading"
        indeterminate
        size="20"
        width="3"
        color="primary"
        class="ml-3"
      />
      <span
        v-else
        class="pl-3"
      >
        {{ (epfDetail||{}).epf_member_number ||'N/A' }}
      </span>
      <employee-profile-payroll-epf-detail-dialog-edit
        v-if="$hasPermissionTo(['update employee payroll']) && !isResigned && !loading"
        :epf-detail="epfDetail"
        :employee-uid="employeeUid"
        @updated="loadEmployeeEpf"
      />
    </v-col>
  </v-row>
</template>

<script>
  export default {
    components: {
      EmployeeProfilePayrollEpfDetailDialogEdit: () => import('@/components/hris/employee/profile/payroll/epf-detail/DialogEdit'),
    },
    props: {
      employeeUid: {
        type: String,
        required: true,
      },
      isResigned: {
        type: Boolean,
        required: true,
      },
    },
    data () {
      return {
        loading: false,
        epfDetail: {},
      }
    },
    watch: {
      employeeUid: {
        immediate: true,
        handler (newVal, oldVal) {
          if (!_.isEmpty(newVal)) {
            this.loadEmployeeEpf()
          }
        },
      },
    },
  
    methods: {
      loadEmployeeEpf () {
        this.loading = true

        this.$api.employeePayrollEpf().list(this.employeeUid)
          .then(res => {
            this.epfDetail = res.data

            this.loading = false
          })
      },
    },
  }
</script>
